import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { ToasterService } from '../../services/toaster.service';

export const canActivate: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
):
  | Observable<boolean | UrlTree>
  | Promise<boolean | UrlTree>
  | boolean
  | UrlTree => {
  const _authService = inject(AuthService);
  const _toasterService = inject(ToasterService);
  const _router = inject(Router);
  const _translateService = inject(TranslateService);

  if (state.url.includes('/auth/login')) {
    if (_authService.isAuthenticated()) {
      _router.navigate(['/dashboard']);
      return false;
    } else {
      return true;
    }
  } else {
    if (!_authService.isAuthenticated()) {
      _router.navigate(['/auth/login']);
      _toasterService.errToastr(_translateService.instant('LoginFirst'));
      return false;
    } else {
      return true;
    }
  }
};
